import { selectUser } from '@epicuro-next/state/user-state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  basketSwitchFeatureKey,
  State,
} from '../reducers/basket-switch.reducer';

export const selectBasketSearchState = createFeatureSelector<State>(
  basketSwitchFeatureKey,
);

export const selectUserBasketSearchData = createSelector(
  selectBasketSearchState,
  (state) => state.userBasketSearchData,
);

export const selectBasketSearchData = createSelector(
  selectBasketSearchState,
  (state) => state.basketSearchData,
);

export const selectBaskets = createSelector(
  selectBasketSearchData,
  (state) => state?.baskets,
);

export const selectAllBasketsLoaded = createSelector(
  selectBasketSearchState,
  (state) => state.allLoaded,
);

export const selectManagerLoading = createSelector(
  selectBasketSearchState,
  (state) => state.loading,
);

export const selectPage = createSelector(
  selectBasketSearchState,
  (state) => state.page,
);

export const selectUsersAmount = createSelector(
  selectBasketSearchState,
  (state) => state.usersAmount,
);

export const selectBasketsCount = createSelector(
  selectBasketSearchState,
  (state) => state.basketsAmount,
);

export const selectBasketManagerOpened = createSelector(
  selectBasketSearchState,
  (state) => state.basketManagerOpened,
);

export const selectIsBasketSwitching = createSelector(
  selectBasketSearchState,
  (state) => state.switching,
);

export const selectCurrentUserBasketsIds = createSelector(
  selectBasketSearchData,
  selectUserBasketSearchData,
  selectUser,
  (basketData, userBasketData, user) => {
    const currentUserBasketsIds = userBasketData
      ? userBasketData?.items
          ?.find(
            (userBasketItem) =>
              userBasketItem?.user?.displayName === user?.displayName,
          )
          ?.baskets?.map((basketItem) => basketItem?.id)
      : basketData?.baskets
          ?.filter((basketItem) => basketItem?.user?.userId === user?.userId)
          .map((basketItem) => basketItem?.basketId);

    return currentUserBasketsIds || [];
  },
);
